"use client";

import Link from "next/link";

export function LinkCover({
  href,
  children,
  className = "",
}: {
  href: string;
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <Link
      href={href}
      className={`group relative inline-flex overflow-hidden ${className}`}
    >
      <span
        aria-hidden="true"
        className="absolute inset-0 origin-left scale-x-0 transition-transform duration-300 ease-out group-hover:scale-x-100"
        style={{ backgroundColor: "#5A7A38" }}
      />
      <span className="relative z-10 transition-colors duration-300 ease-out group-hover:!text-white group-hover:[&_*]:!text-white">
        {children}
      </span>
    </Link>
  );
}
